/**
 * Skeleton — space-reserving loading placeholder.
 * Matches the exact dimensions of the content it replaces so there is
 * no layout shift when real data arrives (§2 "skeleton screens that
 * reserve exact space — never spinners-on-blank").
 *
 * Usage:
 *   <Skeleton style={{ height: 24, width: '60%' }} />
 *   <Skeleton className="h-6 w-1/2" />   (arbitrary Tailwind values)
 *
 * Export: named + default (both work).
 */
export function Skeleton({ className = '', style, ...props }) {
  return (
    <div
      role="presentation"
      aria-hidden="true"
      className={className}
      style={{
        background: 'var(--c-surface-3)',
        borderRadius: '8px',
        animation: 'skeleton-pulse 1.5s ease-in-out infinite',
        ...style,
      }}
      {...props}
    />
  );
}

export default Skeleton;
